export default {
  SHOW_LOADING(state) {
    state.loading = true;
  },

  HIDE_LOADING(state) {
    state.loading = false;
  },
  SHOW_MODAL(state) {
    console.log(state);
    let body = document.body;
    body.classList.add("modal-open");
  },

  DESTROY_MODAL(state) {
    console.log(state);
    let body = document.body;
    body.classList.remove("modal-open");
  },

  SET_NATION_OPTIONS(state, options) {
    state.nationOptions = options;
  }
};
